module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(_vm.config.qaTime) ? _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.menus), function(item, index) {
    return _c('span', {
      key: 'menu-' + index,
      class: {
        active: index == _vm.n
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [(index == _vm.n) ? _c('i', {
      staticClass: "icon iconfont icon-luzhi"
    }) : _vm._e(), _vm._v(" "), (index != _vm.n) ? _c('i', {
      staticClass: "icon iconfont icon-bofang"
    }) : _vm._e(), _vm._v("\n      " + _vm._s(item.name) + "\n      "), (index != 0) ? _c('i', {
      staticClass: "icon iconfont icon-guanbi",
      on: {
        "click": _vm.closeQATag
      }
    }) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "base"
  }, [(!_vm.config.qaTime) ? _c('span', {
    staticClass: "blod"
  }, [_vm._v("教师端")]) : _vm._e(), _vm._v(" "), _c('span', {}, [_vm._v("教室ID：" + _vm._s(_vm.config.roomId))]), _vm._v(" "), _c('span', {}, [_vm._v("在线人数：" + _vm._s(_vm.config.number))])]), _vm._v(" "), (_vm.config.role) ? _c('div', {
    staticClass: "file"
  }, _vm._l((_vm.icons), function(i, index) {
    return _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: i.info,
          classes: 'tips-tooltip',
          placement: 'bottom'
        }),
        expression: "{content: i.info, classes: 'tips-tooltip', placement: 'bottom' }"
      }],
      key: 'control-' + index,
      staticClass: "fi-wrap",
      class: index === 1 && _vm.hasNewQuestion ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.fileOperation(index)
        }
      }
    }, [_c('i', {
      class: ['icon', 'iconfont', i.icon]
    })])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-468eb70e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderV2/index.vue
// module id = 511
// module chunks = 1